export default "__VITE_ASSET__BRXYyMf9__"